export default "__VITE_ASSET__Did0H5MQ__"